import raithuMark from './raithu-mark.png';

const LogoFull = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 30 }}>
    <img
      src={raithuMark}
      alt="RAITHU"
      style={{ height: 30, width: 'auto', display: 'block' }}
    />
    <span
      style={{
        fontFamily: "'Poppins', system-ui, sans-serif",
        fontWeight: 600,
        fontSize: '1.1rem',
        letterSpacing: '0.06em',
        color: '#fff',
        lineHeight: 1,
      }}
    >
      RAITHU
    </span>
  </div>
);

export default LogoFull;
